import React from 'react';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CloseIcon from '@mui/icons-material/Close';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';

const Cart = ({ bookedVehicles, onRemove, onPrint, onBook, onClose, calculateTotalPrice, packages }) => {
  const navigate = useNavigate();
  const totalAmount = calculateTotalPrice(bookedVehicles);

  const getPriceForVehicle = (vehicle) => {
    let vehicleTotal = 0;
    vehicle.packages.forEach(pkgName => {
      const pkg = packages.find(p => p.name === pkgName);
      if (pkg && pkg.prices[vehicle.type]) {
        const price = pkg.prices[vehicle.type];
        const priceValue = parseInt(price.replace('KES ', '').replace(',', ''));
        vehicleTotal += priceValue;
      }
    });
    return vehicleTotal;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-end">
      <div className="bg-white w-full max-w-lg h-full shadow-lg flex flex-col">
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-2xl font-bold flex items-center">
            <ShoppingCartIcon className="mr-2" /> Your Cart
          </h2>
          <button onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          {bookedVehicles.length === 0 ? (
            <p>Your cart is empty.</p>
          ) : (
            <ul className="divide-y divide-gray-200">
              {bookedVehicles.map(vehicle => (
                <li key={vehicle.id} className="py-4">
                  <div className="flex justify-between items-start">
                    <div>
                      <p className="font-bold">{vehicle.model} ({vehicle.type})</p>
                      <p className="text-sm text-gray-600">{vehicle.packages.join(', ')}</p>
                    </div>
                    <div className="text-right">
                      <p className="font-semibold">KES {getPriceForVehicle(vehicle).toLocaleString()}</p>
                      <button onClick={() => onRemove(vehicle.id)} className="text-red-500 hover:text-red-700">
                        <DeleteIcon />
                      </button>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="p-4 border-t">
          <div className="flex justify-between items-center font-bold text-xl mb-4">
            <span>Total:</span>
            <span>KES {totalAmount.toLocaleString()}</span>
          </div>
          <div className="flex gap-4">
            <button
              onClick={onPrint}
              disabled={bookedVehicles.length === 0}
              className="w-full flex items-center justify-center gap-2 py-3 px-4 bg-gray-300 text-black rounded-lg hover:bg-gray-400 disabled:opacity-50"
            >
              <PrintIcon /> Print
            </button>
            <button
              onClick={() => {
                if (bookedVehicles.length === 0) {
                  onClose();
                  navigate('/booking');
                } else {
                  onBook();
                }
              }}
              className="w-full mt-4 h-12 rounded-2xl text-white font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              style={{background: "linear-gradient(135deg, #3b82f6, #1d4ed8)"}}
            >
              {bookedVehicles.length === 0 ? 'Add Package' : 'Book Now'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
